import { render, staticRenderFns } from "./SVGDropdownSwitchArrowUp.vue?vue&type=template&id=4bf4aff8&scoped=true&"
import script from "./SVGDropdownSwitchArrowUp.vue?vue&type=script&lang=js&"
export * from "./SVGDropdownSwitchArrowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf4aff8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf4aff8')) {
      api.createRecord('4bf4aff8', component.options)
    } else {
      api.reload('4bf4aff8', component.options)
    }
    module.hot.accept("./SVGDropdownSwitchArrowUp.vue?vue&type=template&id=4bf4aff8&scoped=true&", function () {
      api.rerender('4bf4aff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGDropdownSwitchArrowUp.vue"
export default component.exports